import { useState } from "react";
import { Lock, PlayCircle, Clock, X } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

function LessonChip({ ls, i, n, paid, fr, onPlay, ci }) {
  const ready = ls.has_video;
  const playable = ready && paid && ls.video_id;
  return (
    <button type="button" disabled={!playable} onClick={() => onPlay(ls)} data-testid={`lesson-${ci}-${i}`}
      className={`w-full flex items-center gap-3 text-left rounded-xl border-2 px-3 py-2.5 transition-transform ${
        playable ? "border-slate-900 bg-white hover:translate-x-0.5 hover:translate-y-0.5 cursor-pointer" : "border-slate-300 bg-slate-50 text-slate-600 cursor-not-allowed"}`}
      style={playable ? { boxShadow: "3px 3px 0 0 #0F172A" } : {}}>
      <span className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold shrink-0 ${playable ? "bg-red-500 text-white" : "bg-slate-200 text-slate-400"}`}>{n}</span>
      <span className="flex-1 min-w-0">
        <span className="block text-sm font-bold leading-tight" data-testid={`lesson-title-${ci}-${i}`}>{ls.title}</span>
        {ls.duration && <span className="text-xs font-parent text-slate-500" data-testid={`lesson-duration-${ci}-${i}`}>{ls.duration} min</span>}
      </span>
      {playable ? <PlayCircle size={20} className="text-red-500 shrink-0" />
        : ready ? <Lock size={16} className="shrink-0" />
          : <span className="inline-flex items-center gap-1 text-xs font-parent font-bold text-amber-700 bg-amber-100 rounded-full px-2 py-0.5 shrink-0" data-testid={`lesson-soon-${ci}-${i}`}><Clock size={12} /> {fr ? "Bientôt" : "Coming soon"}</span>}
    </button>
  );
}

export default function LessonVideos({ lessons, paid, fr, ci, start = 0 }) {
  const [playing, setPlaying] = useState(null);
  if (!lessons?.length) return null;
  const ready = lessons.filter((l) => l.has_video).length;
  return (
    <div className="mb-5" data-testid={`lessons-${ci}`}>
      <p className="text-xs font-parent font-bold uppercase tracking-wide text-slate-500 mb-2">
        {fr ? "Leçons en vidéo" : "Video lessons"} · {ready}/{lessons.length}
      </p>
      <div className="grid sm:grid-cols-2 gap-2">
        {lessons.map((ls, i) => <LessonChip key={ls.id} ls={ls} i={i} n={start + i + 1} ci={ci} paid={paid} fr={fr} onPlay={setPlaying} />)}
      </div>
      <Dialog open={!!playing} onOpenChange={(o) => !o && setPlaying(null)}>
        <DialogContent className="max-w-3xl p-0 overflow-hidden border-4 border-slate-900 bg-slate-900 [&>button]:hidden" data-testid="lesson-video-modal">
          <div className="flex items-center gap-3 px-4 py-3 bg-white">
            <DialogTitle className="flex-1 font-kids text-lg" data-testid="lesson-video-title">{playing?.title}</DialogTitle>
            <button onClick={() => setPlaying(null)} className="rounded-full p-1.5 hover:bg-slate-100" data-testid="lesson-video-close"><X size={18} /></button>
          </div>
          {playing && (
            <div className="aspect-video bg-black">
              <iframe title={playing.title} className="w-full h-full" allow="autoplay; encrypted-media; fullscreen" allowFullScreen
                src={`https://www.youtube-nocookie.com/embed/${playing.video_id}?autoplay=1&rel=0&modestbranding=1&playsinline=1`} data-testid="lesson-video-frame" />
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
